import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';

// tag - array of strings
// onRemoveTag - tag => void
// onNewTag - () => void
// also see defaults

export default function TagGroup({
    onNewTag,
    tags= [],
    margin= 4,
    newLabel= "New",
    color= '',
    disabledColor = '#bbbbbb',
    onRemoveTag= ()=>{}, //NOP
    maxLength= 20,
    disabled = false,
    ...props
}) {

    return <>
        {tags.map((tag) => {

            const isLongTag = tag.length > maxLength;

            const tagElem = (
                <Tag key={tag}
                     closable={true} onClose={e=>disabled?e.preventDefault():onRemoveTag(tag)}
                     style={{ margin }} color={disabled?disabledColor:color}
                     {...props}
                >
                    {isLongTag ? `${tag.slice(0, maxLength)}...` : tag}
                </Tag>
            );
            return isLongTag ? (
                <Tooltip title={tag} key={tag}>
                    {tagElem}
                </Tooltip>
            ) : (
                tagElem
            );
        })}
        {onNewTag && (
            <Tag
                onClick={e=>disabled?e.preventDefault():onNewTag()}
                style={{ backgroundColor: disabled?disabledColor:'#fff', borderStyle: 'dashed', margin }}
                {...props}
            >
                <PlusOutlined />{newLabel}
            </Tag>
        )}
    </>;
}

// Note setting color on New Tag this way caused antd apply other styles that whited out the button
// regular tags may have the same problem
// color={disabled?disabledColor:'#fff'}